import React from "react"
import PropTypes from "prop-types"

import {BOOKMARK_TYPE} from "@irati-web/insights/src/utils/constants/comment"

import UpdateCommentMutation from "./update"

const ToggleTagOnCommentMutation = ({children, note, comment, ...props}) => {
  const {tags, id} = comment
  const hasBookmark = tags.find((tag) => tag.type === BOOKMARK_TYPE)
  const variables = {id}
  if (hasBookmark) {
    variables.tags = tags.filter((tag) => tag.type !== BOOKMARK_TYPE)
  } else {
    variables.tags = [
      ...tags,
      {
        type: BOOKMARK_TYPE,
        __typename: "InsightsCommentTag",
        data: {note, id: null, sentiment: null, __typename: "InsightsCommentTagData"}
      }
    ]
  }

  const optimisticResponse = {
    __typename: "Mutation",
    updateInsightsComment: {
      __typename: "InsightsComment",
      ...comment,
      tags: variables.tags
    }
  }

  const refetchQueries = () => ["InsightsCommentTagCount"]

  return (
    <UpdateCommentMutation {...props} variables={variables}>
      {(mutate, apolloState) => {
        return children(
          (args) => mutate({optimisticResponse, refetchQueries, ...args}),
          apolloState
        )
      }}
    </UpdateCommentMutation>
  )
}

ToggleTagOnCommentMutation.propTypes = {
  children: PropTypes.func.isRequired,
  comment: PropTypes.object,
  note: PropTypes.string
}

ToggleTagOnCommentMutation.defaultProps = {
  comment: {},
  note: null
}

export default ToggleTagOnCommentMutation
